module.exports = __webpack_public_path__ + "media/images/icon-more-big@3x-9816e8e3b463d43b241efe356c3195f0.png";